var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2085_9373)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0051 0C11.3119 0 10.6372 0.247791 10.1139 0.704695L10.0961 0.720241L10.0769 0.738669L0.92526 9.02862C0.637614 9.28386 0.405257 9.59571 0.245083 9.9461C0.083886 10.2987 -3.85642e-05 10.6816 0 11.0696V21.2399C0 21.9853 0.308834 22.6916 0.844407 23.2058C1.37859 23.7187 2.09473 24 2.83333 24H7.41666C8.15526 24 8.8714 23.7187 9.40558 23.2058C9.94115 22.6916 10.25 21.9853 10.25 21.2399V16.9594H13.75V21.2399C13.75 21.9853 14.0588 22.6916 14.5944 23.2058C15.1286 23.7187 15.8447 24 16.5833 24H21.1666C21.9052 24 22.6214 23.7187 23.1556 23.2058C23.6911 22.6916 24 21.9853 24 21.2399V11.072V11.0695H23.0001L24 11.0751L24 11.072C24.0017 10.6861 23.9203 10.3051 23.7623 9.95333C23.6044 9.60168 23.3739 9.28815 23.0876 9.03097L23.0854 9.02898L13.9496 0.753415L13.94 0.742779L13.8963 0.704695C13.373 0.247791 12.6984 0 12.0051 0ZM13.75 16.9594V16.8395C13.75 16.8847 13.7691 16.9195 13.7889 16.9385C13.8074 16.9563 13.8241 16.9594 13.8333 16.9594H13.75ZM10.25 16.9594H10.1667C10.1759 16.9594 10.1926 16.9563 10.211 16.9385C10.2309 16.9195 10.25 16.8847 10.25 16.8395V16.9594ZM10.7591 1.47007L10.0665 0.748712L10.0769 0.738669L10.0877 0.72893L10.3546 1.02353L10.7591 1.47007ZM1.59239 9.77357L0.921043 9.03244L0.92526 9.02862L0.930568 9.02392L1.59239 9.77357Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2085_9373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.2fafd66001d4dda12ad9242042c1795e.svg";
export { ForwardRef as ReactComponent };